import { Button, Col, Modal, Row } from 'antd'
import styled from 'styled-components'
import { formatCurrency } from 'src/utils/helper'
import usePayment from 'src/store/hooks/payment'
import { useState } from 'react'
import { apiCreateOrder } from 'src/store/sagas/payment'
import addNotification, { NOTIFICATION_TYPE } from 'src/utils/toast'

export const ModalStyled = styled(Modal)`
  border-radius: 20px;
  color: #000;
  background: #fff .ant-modal-content {
    background: #13151d;
    width: 500px;
  }

  ::placeholder {
    color: #757575;
    font-size: 14px;
    font-weight: 400;
  }
`
export const PaymentPage = (props) => {
  const { actions } = usePayment()
  const { data } = props
  const [showQRCode, setShowQRCode] = useState(false)
  const [qrCodeBase64, setQrCodeBase64] = useState('')
  const onSubmitPayment = async () => {
    const body = {
      eventCode: data.eventCode,
      areaCode: data.areaCode,
      seat: data.seat.map((item) => item.name),
    }
    const res = await apiCreateOrder(body)
    if (res.statusCode === 200) {
      setShowQRCode(true)
      setQrCodeBase64(res.data.qrDataURL)
    }
    if (res.statusCode !== 200) {
      props.setOpenPayment(false)
      addNotification(
        res.message,
        NOTIFICATION_TYPE.ERROR,
        'Đặt vé không thành công!',
      )
    }
    return
  }
  const onCancelPayment = () => {
    setShowQRCode(false)
    setQrCodeBase64('')
    props.setOpenPayment(false)
    return
  }

  return (
    <ModalStyled
      open={props.open}
      closable={true}
      onCancel={() => onCancelPayment()}
      footer={null}
      wrapClassName="!bg-[#00000070]"
      className="relative"
    >
      {showQRCode && (
        <>
          <Row gutter={24}>
            <img src={qrCodeBase64} alt="QR Code" className="w-full h-auto" />
            <p className="mt-2 text-black text-xl text-center">
              Vui lòng quét mã để chuyển khoản. Lưu ý không thay đổi nội dung
              chuyển khoản!
            </p>
          </Row>
        </>
      )}
      {!showQRCode && (
        <>
          <Row gutter={24}>
            <Col span={24}>
              <h1 className="text-center w-full text-xl">Thông tin đặt vé</h1>
              <p className="mt-4 text-lg">Loại vé: {data?.areaName}</p>
            </Col>
          </Row>
          <Row gutter={24} className="mt-2">
            <Col className="text-lg" span={12}>
              <p>Ghế</p>
            </Col>
            <Col className="text-lg text-right" span={12}>
              <p>Giá</p>
            </Col>
            {data &&
              data.seat.map((seat) => (
                <>
                  <Col className="" span={12}>
                    <p key={seat.id}>{seat.name}</p>
                  </Col>
                  <Col className="text-right" span={12}>
                    <p key={seat.id}>{seat.price}</p>
                  </Col>
                </>
              ))}
            <Col span={24}>
              <div className="border-t border-white mt-2 pt-2 border-dashed"></div>
            </Col>
            <Col span={12} className="">
              <p>Tạm tính {data ? data?.seat.length : 0} ghế:</p>
            </Col>
            <Col span={12} className="text-right">
              <p>
                {data
                  ? formatCurrency(data?.seat.reduce((c, n) => c + n.price, 0))
                  : 0}
              </p>
            </Col>
            <Col span={24}>
              <Button
                className="mt-4 w-[280px] m-auto block bg-[#38b6ff] text-white border-none btn-pay"
                onClick={onSubmitPayment}
              >
                Thanh toán
              </Button>
              <Button
                className="mt-2 w-[280px] m-auto block bg-[#ff383e] !text-white border-none"
                onClick={onCancelPayment}
              >
                Huỷ
              </Button>
            </Col>
          </Row>
        </>
      )}
    </ModalStyled>
  )
}
